import {
  SET_SEARCHKEYWORD
} from "../actions/types";

const initialState = {
  keyword: ''
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCHKEYWORD:
      return {
        ...state,
        keyword: action.payload
      };
    default:
      return state;
  }
}
